const staticdata = "https://propelld.com/api/static";
const customer = "https://propelld.com/api/customer";
const propelldLoan = "https://loan.propelld.com/";

const baseUrls = {
	customer,
	staticdata,
	propelldLoan,
};

export default baseUrls;
